import numOrDefault from 'lib/helpers/numOrDefault';
import { ia } from 'lib/helpers/utility';

import { amountToCents } from '../../Claims/CMS1500/lib/amountToCents';
import { denied_codes, patient_responsibility } from '../../lib/insuranceAdjustmentGroups';

export const calcPtBalance = ({ procedure }) => {
  let primaryAdj = 0;
  let secondaryAdj = 0;
  let tertiaryAdj = 0;
  const insTypes = ['primary', 'secondary', 'tertiary'];

  insTypes.forEach((insType) => {
    const adjustments = procedure?.[insType];
    if (ia(adjustments)) {
      const lastAdjustment = adjustments[adjustments?.length - 1];
      let typeAdj = 0;

      if (ia(lastAdjustment?.ins_adj)) {
        lastAdjustment.ins_adj.forEach((item) => {
          const { group, code, amount } = item;

          const hasPRCode = patient_responsibility[group]?.includes(+code);
          const hasDeniedCode = denied_codes[group]?.includes(code);

          if (lastAdjustment?.patient_responsibility === false) {
            if (!(group === 'PR' && +code === 45)) {
              if (group === 'PR' || hasPRCode || hasDeniedCode) {
                typeAdj += amountToCents(amount);
              }
            }
          } else {
            if (group === 'PR' || hasPRCode || hasDeniedCode) {
              typeAdj += amountToCents(amount);
            }
          }
        });
      }

      if (ia(lastAdjustment?.pt_adj)) {
        lastAdjustment.pt_adj.forEach((item) => {
          const { group, code, amount } = item;

          const hasPRCode = patient_responsibility[group]?.includes(+code);
          const hasDeniedCode = denied_codes[group]?.includes(code);

          if (lastAdjustment?.patient_responsibility === false) {
            if (!(group === 'PR' && +code === 45)) {
              if (group === 'PR' || hasPRCode || hasDeniedCode) {
                typeAdj += amountToCents(amount);
              }
            }
          } else {
            if (group === 'PR' || hasPRCode || hasDeniedCode) {
              typeAdj += amountToCents(amount);
            }
          }
        });
      }

      if (insType === 'primary') {
        primaryAdj = typeAdj;
      } else if (insType === 'secondary') {
        secondaryAdj = typeAdj;
      } else if (insType === 'tertiary') {
        tertiaryAdj = typeAdj;
      }
    }
  });

  return primaryAdj - secondaryAdj - tertiaryAdj;
};

export const formatProcedureAdjustments = ({ procDetails, adjustments }) => {
  const adjustmentsLength = adjustments?.length - 1 || 0;

  let insAdj = 0;
  adjustments[adjustmentsLength]?.ins_adj?.forEach((item) => {
    const { group, code, amount } = item;

    const hasPRCode = patient_responsibility[group]?.includes(+code);
    const hasDeniedCode = denied_codes[group]?.includes(code);

    if (group !== 'PR' && !hasPRCode && !hasDeniedCode) {
      insAdj += amountToCents(amount);
    }
  });

  let ptAdj = 0;
  adjustments[adjustmentsLength]?.ins_adj?.forEach((item) => {
    const { group, code, amount } = item;

    const hasPRCode = patient_responsibility[group]?.includes(+code);
    const hasDeniedCode = denied_codes[group]?.includes(code);

    if (group === 'PR' || !!hasPRCode || !!hasDeniedCode) {
      ptAdj += amountToCents(amount);
    }
  });

  if (ia(adjustments[adjustmentsLength]?.pt_adj)) {
    adjustments[adjustmentsLength]?.pt_adj?.forEach((item) => {
      const { group, code, amount } = item;

      const hasPRCode = patient_responsibility[group]?.includes(+code);
      const hasDeniedCode = denied_codes[group]?.includes(code);

      if (group === 'PR' || !!hasPRCode || !!hasDeniedCode) {
        ptAdj += amountToCents(amount);
      }
    });
  }

  const ins_balance =
    numOrDefault(procDetails?.charge) -
    numOrDefault(insAdj) -
    numOrDefault(adjustments[adjustmentsLength]?.paid) -
    numOrDefault(procDetails?.other_adj) -
    numOrDefault(ptAdj);

  const childrenItemRow = {
    ...procDetails,
    ins_adjustment: insAdj,
    ins_payment: adjustments[adjustmentsLength]?.paid,
    ptBalance: ptAdj,
    ins_balance
  };

  return childrenItemRow;
};

export const formatInvoiceProcedures = ({ invoices = [] }) => {
  const rows = [];

  invoices?.forEach((item) => {
    const calculatedInsBalance =
      numOrDefault(item?.charge) -
      numOrDefault(item?.ins_adjustment) -
      numOrDefault(item?.ins_payment) -
      numOrDefault(item?.other_adj) -
      numOrDefault(item?.pt_balance);

    const ins_balance = item?.isEstimated
      ? item?.charge - numOrDefault(item?.other_adj)
      : calculatedInsBalance;

    const itemRow = {
      ...item,
      details: item?.details,
      dateofservice: item?.dateofservice,
      type: ia(item?.primary) ? '-' : item?.type,
      qty: item?.qty,
      charge: item?.charge,
      ins_payment: item?.ins_payment,
      ptBalance: item?.ptBalance
        ? item?.ptBalance
        : ia(item?.primary)
          ? calcPtBalance({ procedure: item })
          : null,
      ins_adjustment: item?.isEstimated
        ? item?.ins_adjustment
        : !ia(item?.primary)
          ? item?.ins_adjustment
          : null,
      ins_balance
    };

    const children = [];
    if (ia(item?.primary)) {
      children.push(
        formatProcedureAdjustments({
          procDetails: {
            details: item?.details,
            dateofservice: item?.dateofservice,
            type: 'Primary',
            qty: item?.qty,
            charge: item?.charge
          },
          adjustments: item?.primary
        })
      );
    }

    if (ia(item?.secondary)) {
      children.push(
        formatProcedureAdjustments({
          procDetails: {
            details: item?.details,
            dateofservice: item?.dateofservice,
            type: 'Secondary',
            qty: item?.qty,
            charge: item?.charge
          },
          adjustments: item?.secondary
        })
      );
    }

    if (ia(item?.tertiary)) {
      children.push(
        formatProcedureAdjustments({
          procDetails: {
            details: item?.details,
            dateofservice: item?.dateofservice,
            type: 'Tertiary',
            qty: item?.qty,
            charge: item?.charge
          },
          adjustments: item?.tertiary
        })
      );
    }

    if (ia(children)) {
      itemRow.children = children;
    }

    rows.push(itemRow);
  });
  return rows;
};
